export const initialAuthState = {
  isInitialized: false,
  isAuthenticated: false,
  error: undefined,
  use_frame: false,
}
